/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_FranchiseInputs */

const cs_nav_franchise = /** @type {(inputs: Nav_FranchiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licence`)
};

const en_nav_franchise = /** @type {(inputs: Nav_FranchiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licenses`)
};

/**
* | output |
* | --- |
* | "Licenses" |
*
* @param {Nav_FranchiseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_franchise = /** @type {((inputs?: Nav_FranchiseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_FranchiseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_franchise(inputs)
	return cs_nav_franchise(inputs)
});